import {
  Home,
  FolderKanban,
  Briefcase,
  TrendingUp,
  FileText,
  DollarSign,
  BarChart3,
  Users,
  Calendar,
  Settings,
  FolderOpen,
  BookUser,
} from "lucide-react";
import type { MenuItem } from "../types";

/**
 * Menu Items Configuration
 * Define your menu structure here based on Discovery analysis
 */
export const menuItems: MenuItem[] = [
  // Main Group
  { id: "dashboard", label: "Homepage", icon: Home, page: "dashboard" },
  { id: "projects", label: "Projects", icon: FolderKanban, page: "projects" },
  { id: "portfolio", label: "Portfolio", icon: Briefcase, page: "portfolio" },
  
  // Resources Group (with sub-menu)
  { 
    id: "resources-menu", 
    label: "Resources", 
    icon: FolderOpen, 
    page: "resources-menu",
    children: [
      { id: "directory", label: "Directory", icon: BookUser, page: "directory" },
      { id: "resources", label: "Resource Allocation", icon: Users, page: "resources" },
      { id: "utilisation", label: "Utilisation", icon: TrendingUp, page: "utilisation" },
    ]
  },
  
  // Financial Group
  { id: "wip-reporting", label: "WIP Reporting", icon: FileText, page: "wip-reporting" },
  { id: "profitability", label: "Profitability", icon: DollarSign, page: "profitability" },
  { id: "budgets", label: "Budgets & Variance", icon: BarChart3, page: "budgets" },
  
  // Planning Group
  { id: "gantt", label: "Gantt Charts", icon: Calendar, page: "gantt" },
];

/**
 * Database Options Configuration
 * Not used - company selector remains in header
 */
export const databases = [];

/**
 * Menu Configuration
 */
export const menuConfig = {
  /** Total number of pages (10 main pages including sub-menu items) */
  totalPages: 10,
  /** Minimum pages required to enable favorites feature */
  favoritesThreshold: 10,
  /** Show database switcher in footer - NO (company selector in header) */
  showDatabaseSwitcher: false,
  /** Show settings button in footer - YES */
  showSettings: true,
};
